import { gsap, ScrollTrigger } from "@/composeables/gsap"

function animateCounter(el, index, duration, locale) {
    const target = parseFloat(el.dataset.kpiValue)
    if (isNaN(target)) return

    const countEl = el.querySelector(".section-kpi-counter__count")
    if (!countEl) return

    const obj = { value: 0 }
    const fmt = (n) => Math.round(n).toLocaleString(locale)

    gsap.to(obj, {
        value: target,
        duration,
        delay: index * 0,
        ease: "expo.inOut",
        onUpdate() {
            countEl.textContent = fmt(obj.value)
        },
        onComplete() {
            countEl.textContent = fmt(target)
        },
    })
}

function createSectionAnimation(section) {
    const numbers = section.querySelectorAll(".section-kpi-counter__number")
    const duration = parseFloat(section.dataset.animationDuration) || 1
    const locale = section.dataset.locale || navigator.language

    ScrollTrigger.create({
        trigger: section,
        start: "top 80%",
        once: true,
        onEnter() {
            numbers.forEach((el, i) => animateCounter(el, i, duration, locale))
        },
    })
}

export const init = () => {
    gsap.utils.toArray(".section-kpi-counter").forEach(createSectionAnimation)
}

export default init
